import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/MsgBoxInfo.svg'


const _hoisted_1 = {
  class: "modal fade",
  id: "MsgBoxInfo",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "MsgBoxInfo",
  "aria-hidden": "true"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-dialog modal-dialog-centered\"><div class=\"modal-content\"><div class=\"modal-header msgbox-info-title-area\"><img src=\"" + _imports_0 + "\" alt=\"\" width=\"20\" height=\"20\"><h6 class=\"modal-title ms-2\" id=\"MsgBoxInfo_Title\"></h6></div><div class=\"modal-body msgbox-info-body-areabody\" id=\"MsgBoxInfo_Message\" style=\"white-space:pre-wrap;word-wrap:break-word;\"></div><div class=\"modal-footer msgbox-info-buttons-area\"><button type=\"button\" id=\"MsgBoxInfo_OkButton\" class=\"btn btn-outline-primary msgbox-info-dialog-buttons\" data-bs-dismiss=\"modal\">OK</button></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  __name: 'MsgBoxInfo',
  setup(__props) {


/********************************************************************************
 * シンプルメッセージボックス(info)
 *
 * @since 2023/03/16
 * @author 松本裕介
 *
 *********************************************************************************/


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})